// material-ui

import vehicleresourceicon from '../../../assets/images/vehicle-resource.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const VehicleResourceIcon = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={vehicleresourceicon} alt="Vehicle Resource" width="22"  />
    );
};

export default VehicleResourceIcon;


